import axios from 'axios';

const BASE_URL =
  'https://us-central1-gamers-world-aa508.cloudfunctions.net/app/api/v1';
// 'http://localhost:5000/gamers-world-aa508/us-central1/app/api/v1';

// const BASE_URL = "http://localhost:5000/api/v1";
// https://us-central1-gamers-world-aa508.cloudfunctions.net/app
const API = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default API;
